import {
    get_headers,
    GET_AVAILABLE_ROLES_URL,
    GET_USER_FOR_ROLES_URL,
    ASSIGN_USER_APPLICATION_URL,
    UNASSIGN_USER_APPLICATION_URL,
    ASSIGNED_USERS_APPLICATION_URL
} from '@/utils/constants/constants';
import axios from 'axios';
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import alert_mixin from '@/utils/mixins/alert_mixin';
import $ from 'jquery';
import NavigationBackButton from '@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue';


export default {
    name: 'AssignmentSection',
    components: {NavigationBackButton },
    mixins: [alert_mixin, formatting_mixins],
    props: {
        title: {
            type: String,
            default: 'Assignment',
        },
        visible: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        headers: get_headers(),
        available_roles: [],
        available_users: [],
        selected_role: null,
        is_loading_roles: false,
        is_loading_users: false,
        is_saving: false,
        table_safe_form_list: [],
        form_table_headers: [],
        assign_selected_role_id: '',
        dataTable: null,
        table_key: 0,     
        application_id: null,
        assigned_rows: [],
        project_id: sessionStorage.getItem("project_id") || null,
    }),

    mounted() {
        this.application_id = sessionStorage.getItem('application_id');
        this.get_available_roles();
        this.load_assigned_rows();
        $('#assign_application')
            .on('shown.bs.modal', () => this.refresh_data_table())
            .on('hidden.bs.modal', () => this.destroy_data_table());
    },
    beforeUnmount() {
        $('#assign_application')
            .off('shown.bs.modal')
            .off('hidden.bs.modal');
        this.destroy_data_table();
    },

    methods: {
        initialize_data_table() {
            this.$nextTick(() => {
            const element = this.$refs.assignUsersTable;
            if (!element || this.dataTable) return;
            this.dataTable = $(element).DataTable({
                responsive: true,
                autoWidth: false,
                pageLength: 10,
            });
            });
        },

        refresh_data_table() {
            // Only rebuild when there are real rows
            if (!this.table_safe_form_list || this.table_safe_form_list.length === 0) {
                this.destroy_data_table();
                return;
            }
            this.destroy_data_table();
            this.initialize_data_table();
        },

        async rebuild_data_table() {
            this.destroy_data_table();
            // bump key so Vue recreates the <table> from scratch
            this.table_key += 1;
            await this.$nextTick();
            this.initialize_data_table();
        },

        destroy_data_table() {
            if (this.dataTable) {
                this.dataTable.destroy(false);
                this.dataTable = null;
            }
        },

        transform_user_data() {
            const users_for_selected_role = Array.isArray(this.available_users) ? this.available_users : [];
            const application_assignments   = Array.isArray(this.assigned_rows) ? this.assigned_rows : [];

            // Build fast lookups from flat assignment rows:
            // - assigned_profile_ids: Set of profile IDs currently assigned to this application
            // - assignment_by_profile_id: Map profile_id -> assignment row
            const assigned_profile_ids = new Set();
            const assignment_by_profile_id = new Map();

            for (const assignment of application_assignments) {
                const profile_id = Number(assignment.assigned_to_id);
                if (Number.isFinite(profile_id)) {
                assigned_profile_ids.add(profile_id);
                if (!assignment_by_profile_id.has(profile_id)) {
                    assignment_by_profile_id.set(profile_id, assignment);
                }
                }
            }

            if (users_for_selected_role.length === 0) {
                this.table_safe_form_list = [];
                this.$nextTick(() => this.initialize_data_table());
                return;
            }

            const table_rows = users_for_selected_role.map(user => {
                const normalized_user_id = Number( user.user_id);
                const normalized_profile_id = user.profile_id != null ? Number(user.profile_id) : null;
                const fallback_user_id = Number(user.id);

                // A user is considered assigned if their profile/user id matches any assigned profile id
                const is_assigned =
                assigned_profile_ids.has(normalized_user_id) ||
                assigned_profile_ids.has(fallback_user_id) ||
                (normalized_profile_id !== null && assigned_profile_ids.has(normalized_profile_id));

                // Keep a reference to a matching assignment row (optional, harmless if not used)
                const matched_assignment =
                assignment_by_profile_id.get(normalized_user_id) ||
                assignment_by_profile_id.get(fallback_user_id) ||
                (normalized_profile_id !== null ? assignment_by_profile_id.get(normalized_profile_id) : null);

                return {
                    id: user.id,                        // stable key for v-for
                    user_id: normalized_user_id,
                    profile_id: normalized_profile_id,
                    user_name: user.user_name || '',
                    email: user.email || '',
                    is_assigned,
                    assignment_id: matched_assignment ? matched_assignment.id : null,
                    is_loading: false,
                };
            });

            this.form_table_headers = Object.keys(table_rows[0]);
            this.table_safe_form_list = table_rows;

            this.$nextTick(() => this.initialize_data_table());
        },


        get_available_roles() {
            this.is_loading_roles = true;
            axios.get(GET_AVAILABLE_ROLES_URL, {
                headers: this.headers,
            })
            .then(response => {
                const parsed_response = response.data;
                if (parsed_response.data && parsed_response.data.length > 0) {
                    this.available_roles = parsed_response.data;
                    if (this.available_roles.length > 0) {
                        this.assign_selected_role_id = this.available_roles[0].id;
                        this.get_users_belonging_to_role(this.assign_selected_role_id);
                    }
                } else {
                    this.available_roles = [];
                }
            })
            .catch(error => {
                this.show_error('Error available roles: ' + (error.response?.data?.message || error.message));
                this.forms = [];
            });
        },

        async on_role_change() {
            if (!this.assign_selected_role_id && !this.project_id) {

                //Unmount table if neither role nor project is selected
                this.table_safe_form_list = [];
                await this.rebuild_data_table();
                return;
            }

            //Unmount table BEFORE fetching (prevents patching errors)
            this.table_safe_form_list = [];
            await this.rebuild_data_table();

            this.is_loading_users = true;
            try {
                //Dynamic parameter: prefer project_id if available
                const params = { project_id: this.project_id,
                    role_id: this.assign_selected_role_id };

                const { data } = await axios.get(GET_USER_FOR_ROLES_URL, {
                headers: this.headers,
                params,
                });

                let res = {};
                if (typeof data === "string") {
                try {
                    res = JSON.parse(data);
                } catch (e) {
                    console.error("Failed to parse response JSON:", e);
                    res = { data: [] };
                }
                } else if (data && typeof data === "object") {
                res = data;
                } else {
                res = { data: [] };
                }

                //Assign fetched users
                this.available_users = res.data || [];

                await this.load_assigned_rows(); // can stay as is
                this.transform_user_data(); // fills table_safe_form_list

                // Mount table and init DT AFTER rows exist
                await this.rebuild_data_table();
            } catch (error) {
                this.available_users = [];
                this.table_safe_form_list = [];
                this.show_error?.(
                "Error loading users: " +
                    (error.response?.data?.message || error.message)
                );
                await this.rebuild_data_table();
            } finally {
                this.is_loading_users = false;
            }
        },



        get_users_belonging_to_role(role_id) {
            this.table_safe_form_list = [];
            this.rebuild_data_table();

            this.is_loading_users = true;
            const params = { project_id: this.project_id, role_id: role_id };

            axios
                .get(GET_USER_FOR_ROLES_URL, {
                headers: this.headers,
                params,
                })
                .then((response) => {
                const data = response.data;
                const res =
                    typeof data === "string"
                    ? JSON.parse(data)
                    : data && typeof data === "object"
                    ? data
                    : { data: [] };

                this.available_users = res.data || [];
                this.transform_user_data();
                return this.rebuild_data_table();
                })
                .catch((error) => {
                this.available_users = [];
                this.table_safe_form_list = [];
                this.show_error?.(
                    "Error loading users: " +
                    (error.response?.data?.message || error.message)
                );
                return this.rebuild_data_table();
                })
                .finally(() => {
                this.is_loading_users = false;
                });
            },

        async toggle_assignment(user_data) {
            const target_state = user_data.is_assigned;
            const prev_state = !target_state;
            user_data.is_loading = true;

            try {
            if (target_state) {
                await axios.post(
                ASSIGN_USER_APPLICATION_URL,
                {
                    application_id: Number(this.application_id),
                    user_id: Number(user_data.user_id),
                    role_id: Number(this.assign_selected_role_id),
                },
                { headers: this.headers }
                );
                this.show_success?.('Assigned successfully.');
                window.location.reload();
            } else {
                await axios.post(
                UNASSIGN_USER_APPLICATION_URL,
                {
                    application_id: Number(this.application_id),
                    user_id: Number(user_data.user_id),
                },
                { headers: this.headers }
                );
                user_data.assignment_id = null;
                this.show_success?.('Unassigned successfully.');
            }
            } catch (err) {
                user_data.is_assigned = prev_state;
                this.show_error?.(err?.response?.data?.message || err.message || 'Failed to update assignment');
            } finally {
            user_data.is_loading = false;
            // Optional: if your row contents/ordering materially change, rebuild:
            // await this.rebuild_data_table();
            }
        },


        async load_assigned_rows() {
            if (!this.application_id) return;
            const { data } = await axios.get(ASSIGNED_USERS_APPLICATION_URL, {
                headers: this.headers,
                params: { application_id: Number(this.application_id) },
            });
            this.assigned_rows = data?.data || [];
        },

        unassign_user(user) {
            // Show loading feedback (optional)
            user.is_loading = true;

            axios.post(
                UNASSIGN_USER_APPLICATION_URL,
                {
                    application_id: Number(this.application_id),
                    user_id: Number(user.assigned_to_id || user.user_id),
                },
                { headers: this.headers }
            )
            .then(() => {
                this.show_success?.(`User "${user.assigned_to_name}" unassigned successfully.`);

                // Refresh the list of assigned users
                return this.load_assigned_rows();
            })
            .catch((err) => {
                this.show_error?.(
                    err?.response?.data?.message ||
                    err.message ||
                    "Failed to unassign user"
                );
            })
            .finally(() => {
                user.is_loading = false;
            });
        }

    },
};